import { Link as InertiaLink } from '@inertiajs/react'

import { Button } from '@atoms'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('calling_sessions_index')

type GoToSessionButtonProps = {
  session: { id: string }
}

export function GoToSessionButton({ session }: GoToSessionButtonProps) {
  return (
    <InertiaLink href={`/calling_sessions/${session.id}`}>
      <Button rank="primary" size="sm" trailingIcon="arrow-circle-broken-right">
        {t('actions.go_to_session')}
      </Button>
    </InertiaLink>
  )
}
